export const WorkOrderItemDetailStatus = {
	received: 5,
	confirmed: 10,
	allocated: 15,
	picking_printed: 20,
	picked: 25,
	packed: 30,
	weight: 35,
	physical_bo: 40,
	triangulation_bo: 41,
	ddp_bo: 42,
	financial_bo: 45,
	deferment_bo: 50,
	price_bo: 55,
	bo_sot: 56,
	unit_of_issue_bo: 57,
	cadastro_bo: 58,
	canceled_bo: 60,
	canceled_bo_od: 62,
	dispatch: 65,
	invoiced: 70,
	invoice_posted_dsh: 75,
	invoicing: 80,
	error_invoiced: 82,
	invoice_not_authorized: 83,
	denial: 84,
	archived: 85,
	invoice_authorized: 86,
	dealer_or_order_not_accept_back_order: 90,
	canceled: 95,
	rejected: 99
}
